import { Switch } from '@mui/material';
import React from 'react';
import ConfirmDialog from '../../components/confirm-dialog';
import { useSnackbar } from '../../components/toast';
import { USER_ROLE_UPDATE_FAIL, USER_ROLE_UPDATE_NOT_ALLOWED, USER_ROLE_UPDATE_SUCCESS } from '../../helpers/messages';
import { addUserToGroupAPI } from '../../services/group';
import { CustomTooltip } from '../../consts';

const ChangeAdminSwitch = ({ checked, user, onSuccess }) => {
    const [open, setOpen] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(null);
    const showSnackbar = useSnackbar();

    const handleStatusChangeConfirm = async () => {
        try {
            setIsLoading(true)
            await addUserToGroupAPI({
                GroupName: "admin",
                Username: user.userId,
            });
            setOpen(false);
            setIsLoading(false);
            onSuccess();
            showSnackbar(USER_ROLE_UPDATE_SUCCESS);
        } catch (error) {
            console.log(error);
            setIsLoading(false)
            showSnackbar(USER_ROLE_UPDATE_FAIL, "error");
        }
    };

    const renderConfirm = () => {
        const name = user?.firstname ? (user?.firstname + " " + user?.lastname) : user?.email;

        return (<ConfirmDialog
            open={open}
            loading={isLoading}
            onClose={setOpen}
            onConfirm={handleStatusChangeConfirm}
            title="Confirm Role Change"
            okText='Ok'
            message={`Are you sure you want to change the role of ${name} to ${user.admin ? "User" : "Admin"}?`}
        />)
    }

    const handleChange = (e) => {
        if (e.target.checked === false)
            showSnackbar(USER_ROLE_UPDATE_NOT_ALLOWED, 'error');
        else {
            setOpen(true);
        }
    }

    return (
        <>
            {renderConfirm()}
            <CustomTooltip title={checked ? "Admin" : "User"}>
                <Switch
                    inputProps={{ 'aria-label': checked ? "Admin" : "User" }}
                    checked={checked}
                    onChange={(e) => handleChange(e)}
                    sx={{marginLeft: -1.25}}
                />
            </CustomTooltip>
        </>
    )
}

export default ChangeAdminSwitch